import axios, {AxiosAdapter, AxiosPromise} from 'axios'
// @ts-ignore
import buildURL from 'axios/lib/helpers/buildURL';
import LRUCache from "lru-cache";

function buildSortedURL(...args: any[]) {
  const builtURL = buildURL(...args);
  const [urlPath, queryString] = builtURL.split('?');
  if (queryString) {
    const paramsPair = queryString.split('&');
    return `${urlPath}?${paramsPair.sort().join('&')}`;
  }
  return builtURL;
}

const FIVE_MINUTES = 1000 * 60 * 5;
const CAPACITY = 100;

const cacheableURLs: any = {
  '/message/state' : true
}
function cacheAdapterEnhancer(adapter: AxiosAdapter | undefined): AxiosAdapter {
  if(!adapter) throw new Error();
  const defaultCache = new LRUCache<string, AxiosPromise>({ maxAge: FIVE_MINUTES, max: CAPACITY });

  return config => {
    const { url, method, params, paramsSerializer} = config;
    if (url && method === 'get' && cacheableURLs[url] ) {

      // if had provide a specified cache, then use it instead
      const cache: LRUCache<string, AxiosPromise> = defaultCache;

      // build the index according to the url and params
      const index = buildSortedURL(url, params, paramsSerializer);

      let responsePromise = cache.get(index);

      if (!responsePromise) {
        responsePromise = (async () => {
          try {
            return await adapter(config);
          } catch (reason) {
            cache.del(index);
            throw reason;
          }

        })();
        // put the promise for the non-transformed response into cache as a placeholder
        cache.set(index, responsePromise);
        return responsePromise;
      }
      return responsePromise;
    }
    return adapter(config);
  };
}

export const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  adapter: cacheAdapterEnhancer(axios.defaults.adapter),
  timeout: 30000
})
